(()=>{
  const root=document.querySelector('[data-oska-concierge]');
  if(!root)return;
  const panel=root.querySelector('[data-oska-concierge-panel]');
  const aiOpenButtons=[...document.querySelectorAll('[data-oska-concierge-open-top]')];
  const liveOpenButtons=[...document.querySelectorAll('[data-oska-live-chat-open]')];
  const openButtons=[...aiOpenButtons,...liveOpenButtons];
  const closeButton=root.querySelector('[data-oska-concierge-close]');
  const voiceButton=root.querySelector('[data-oska-voice]');
  const status=root.querySelector('[data-oska-status]');
  const roleLabel=root.querySelector('[data-oska-role-label]');
  const title=root.querySelector('[data-oska-title]');
  const description=root.querySelector('[data-oska-description]');
  const handoff=root.querySelector('[data-oska-handoff]');
  const log=root.querySelector('[data-oska-chat-log]');
  const form=root.querySelector('[data-oska-chat-form]');
  const input=root.querySelector('[data-oska-chat-input]');
  const mic=root.querySelector('[data-oska-mic]');
  const endpoint=window.OSKA_AI_ENDPOINT||'';
  const Recognition=window.SpeechRecognition||window.webkitSpeechRecognition;
  const reduced=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const lang=root.dataset.lang==='tr'?'tr':'en';
  const greetings={
    ai:lang==='tr'?'OSKA dijital asistan hazır. Kadın, erkek, koleksiyon, üretim veya markaya özel üretim konusunda sizi yönlendirebilirim.':'OSKA digital assistant is ready. I can guide you through women, men, collections, manufacturing or private label.',
    chat:lang==='tr'?'OSKA otomatik yazılı danışmanı hazır. Canlı bir temsilci bağlı değil; ekibimize iletişim formundan ulaşabilirsiniz.':'OSKA automated text concierge is ready. No human agent is connected; contact our team using the contact form.'
  };
  let mode='ai';
  let voiceOn=true;
  let previousFocus=null;
  let hideTimer=0;
  let openFrame=0;
  let recognition=null;
  let session=0;
  const stopListening=()=>{if(recognition){recognition.abort();recognition=null;}};
  let talkTimer=0;
  let talkId=0;
  const setState=state=>{root.classList.remove('is-speaking','is-listening','is-thinking');if(state)root.classList.add('is-'+state);};
  const talkFor=text=>{const id=++talkId;clearTimeout(talkTimer);setState('speaking');talkTimer=window.setTimeout(()=>{if(id===talkId)setState('')},Math.min(9000,Math.max(1400,String(text).length*55)));return id;};
  const wordPulse=()=>{root.classList.remove('is-word');void root.offsetWidth;root.classList.add('is-word');};

  const contextParams=new URLSearchParams(location.search);
  const context={ref:contextParams.get('ref')||'',collection:contextParams.get('collection')||'',category:contextParams.get('category')||''};
  const localPath=path=>(window.OSKA_ROOT||'/').replace(/\/$/,'')+path;
  const contextPath=path=>{const url=new URL(path,location.origin);if(/contact/.test(url.pathname))Object.entries(context).forEach(([key,value])=>{if(value)url.searchParams.set(key,value)});return localPath(url.pathname)+url.search};
  if(handoff)handoff.href=contextPath('/pages/contact');
  root.querySelectorAll('a[href*="contact-rfq"]').forEach(a=>a.href=contextPath('/pages/contact-rfq'));
  const routes={
    women_rings:'/pages/women-rings',women_necklaces:'/pages/women-necklaces',women_earrings:'/pages/women-earrings',women_bracelets:'/pages/women-bracelets',
    men_rings:'/pages/men-rings',men_necklaces:'/pages/men-necklaces',men_earrings:'/pages/men-earrings',men_bracelets:'/pages/men-bracelets',
    women_collections:'/pages/women-collections',men_collections:'/pages/men-collections',collections:'/pages/collections',manufacturing:'/pages/manufacturing',private_label:'/pages/private-label',about:'/pages/about',rfq:'/pages/contact-rfq',contact:'/pages/contact',search:'/search'
  };
  const labels={
    tr:{open:'Sayfayı aç',rfq:'Teklif formunu aç',contact:'İletişimi aç'},
    en:{open:'Open page',rfq:'Open RFQ',contact:'Open contact'}
  };
  const focusable=()=>[...panel.querySelectorAll('a[href],button:not([disabled]),textarea:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el=>!el.hidden&&el.offsetParent!==null);
  const speak=text=>{
    if(mode==='chat'||!voiceOn||!('speechSynthesis' in window)){talkFor(text);return}
    try{
      speechSynthesis.cancel();
      const utterance=new SpeechSynthesisUtterance(text);
      utterance.lang=lang==='tr'?'tr-TR':'en-US';
      utterance.rate=.92;
      const id=talkFor(text);
      let started=false;
      utterance.onstart=()=>{if(id===talkId){started=true;clearTimeout(talkTimer);setState('speaking')}};
      utterance.onboundary=()=>{if(id===talkId)wordPulse()};
      utterance.onend=()=>{if(id===talkId&&started)setState('')};
      utterance.onerror=()=>{if(id===talkId&&started)setState('')};
      speechSynthesis.speak(utterance);
    }catch(error){talkFor(text)}
  };
  const addMessage=(text,kind='assistant',href='',linkText='')=>{
    const item=document.createElement('div');
    item.className='oska-concierge__message oska-concierge__message--'+kind;
    const copy=document.createElement('p');
    copy.textContent=text;
    item.appendChild(copy);
    if(href){
      const link=document.createElement('a');
      link.href=contextPath(href);
      link.textContent=linkText||labels[lang].open;
      item.appendChild(link);
    }
    log.appendChild(item);
    log.scrollTop=log.scrollHeight;
  };
  const normalized=text=>text.toLocaleLowerCase(lang==='tr'?'tr-TR':'en-US').normalize('NFKD').replace(/[̀-ͯ]/g,'').replace(/ı/g,'i');
  const safeIntent=text=>{
    const q=normalized(text);
    const women=/\b(kadin|women|woman|female)\b/.test(q);
    const men=/\b(erkek|men|man|male)\b/.test(q);
    const ring=/\b(yuzuk|ring|rings)\b/.test(q);
    const necklace=/\b(kolye|necklace|necklaces)\b/.test(q);
    const earring=/\b(kupe|earring|earrings)\b/.test(q);
    const bracelet=/\b(bileklik|bracelet|bracelets|cuff)\b/.test(q);
    let route='';
    if(women&&ring)route=routes.women_rings;
    else if(women&&necklace)route=routes.women_necklaces;
    else if(women&&earring)route=routes.women_earrings;
    else if(women&&bracelet)route=routes.women_bracelets;
    else if(men&&ring)route=routes.men_rings;
    else if(men&&necklace)route=routes.men_necklaces;
    else if(men&&earring)route=routes.men_earrings;
    else if(men&&bracelet)route=routes.men_bracelets;
    if(route)return{answer:lang==='tr'?'İlgili OSKA kategori sayfasını buldum.':'I found the matching OSKA category page.',route,label:labels[lang].open};
    if(women)return{answer:lang==='tr'?'Kadın koleksiyonlarını inceleyin. Yüzük, kolye, küpe ve bileklik kategorilerinden ilerleyebilirsiniz.':'Browse the women’s collections. Continue with rings, necklaces, earrings or bracelets.',route:routes.women_collections,label:labels[lang].open};
    if(men)return{answer:lang==='tr'?'Erkek koleksiyonlarını inceleyin. Yüzük, kolye, bileklik ve küpe kategorilerinden ilerleyebilirsiniz.':'Browse the men’s collections. Continue with rings, necklaces, bracelets or earrings.',route:routes.men_collections,label:labels[lang].open};
    if(/koleksiyon|collection|catalog|katalog/.test(q))return{answer:lang==='tr'?'OSKA kadın ve erkek koleksiyonlarını kategori yapısıyla inceleyebilirsiniz.':'Browse OSKA women’s and men’s collections by category.',route:routes.collections,label:labels[lang].open};
    if(/uretim|manufactur|atelier|atolye|production/.test(q))return{answer:lang==='tr'?'OSKA, İstanbul’daki atölye yapısıyla B2B üretim ve ürün geliştirme hizmetleri sunar.':'OSKA provides B2B manufacturing and product development through its Istanbul atelier.',route:routes.manufacturing,label:labels[lang].open};
    if(/private|label|ozel marka|markaya ozel|custom brand/.test(q))return{answer:lang==='tr'?'Markaya özel üretim talepleri tasarım, ürün geliştirme ve üretim kapsamına göre değerlendirilir.':'Private-label requests are evaluated by design, development and production scope.',route:routes.private_label,label:labels[lang].open};
    if(/malzeme|material|925|silver|gumus|gold|altin|pirlanta|diamond|elmas|kaplama|plating|rodaj/.test(q))return{answer:lang==='tr'?'OSKA; 9, 10, 14 ve 18 ayar altın, doğal pırlanta ve lab pırlanta ile proje bazında 925 ayar gümüş üretir. Model ve adet için teklif isteyin.':'OSKA manufactures in 9K, 10K, 14K and 18K gold, with natural and lab-grown diamonds, and in 925 sterling silver on a project basis. Request a quotation for model-specific details.',route:routes.rfq,label:labels[lang].rfq};
    if(/hakkinda|about|firma|company|kimdir|history|tarih/.test(q)||q==='oska')return{answer:lang==='tr'?'OSKA, İstanbul merkezli takı tasarım ve üretim atölyesidir. Kapalıçarşı ve Sirkeci kuyumculuk geleneğinden gelen üretim kültürünü; 9–18 ayar altın, pırlanta ve lab pırlanta, CAD, numune ve markaya özel üretim kabiliyetleriyle birleştirir.':'OSKA is an Istanbul-based jewelry design and manufacturing atelier, combining Grand Bazaar and Sirkeci craftsmanship with 9K–18K gold, natural and lab-grown diamonds, CAD, sampling and private-label capabilities.',route:routes.about,label:labels[lang].open};
    if(/moq|minim|fiyat|price|cost|teslim|delivery|sure|timeline|kargo|shipping/.test(q))return{answer:lang==='tr'?'En az sipariş adedi, fiyat ve teslim süresi modele, malzemeye, adede ve hedef ülkeye göre belirlenir; burada sayı uydurmuyorum. Teklif formuyla net bilgi alın.':'MOQ, price and delivery timing must be confirmed by model, material, quantity and destination; no unverified figure is provided here. Use RFQ for an exact answer.',route:routes.rfq,label:labels[lang].rfq};
    if(/numune|sample|cad|rfq|teklif|quote|quotation/.test(q))return{answer:lang==='tr'?'Ürün, malzeme, adet ve teslim ülkesini teklif formunda paylaşabilirsiniz.':'Share product, material, quantity and destination country in the RFQ form.',route:routes.rfq,label:labels[lang].rfq};
    if(/iletisim|contact|whatsapp|canli|live chat/.test(q))return{answer:lang==='tr'?'Mevcut doğrulanmış iletişim kanalını açıyorum.':'Open the verified contact channel.',route:routes.contact,label:labels[lang].contact};
    if(/ara|search|bul|find/.test(q))return{answer:lang==='tr'?'Site aramasını kullanabilirsiniz.':'Use the site search.',route:routes.search,label:labels[lang].open};
    return{answer:lang==='tr'?'Bu konuda doğrulanmış bir yanıtım yok. Bilgi uydurmak yerine talebinizi teklif formu ya da iletişim sayfası üzerinden OSKA ekibine iletin.':'I do not have a verified answer for that. Rather than invent information, please send the request to OSKA through RFQ or Contact.',route:routes.contact,label:labels[lang].contact};
  };
  const askBackend=async message=>{
    if(!endpoint)return null;
    try{
      const response=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({message,language:lang,country:root.dataset.country,context:{page:root.dataset.context,...context},contextUrl:location.href,mode,scope:'OSKA verified storefront content'})});
      if(!response.ok)return null;
      const data=await response.json();
      return data&&typeof data.reply==='string'&&data.reply.trim()?data.reply.trim():null;
    }catch(error){return null}
  };
  const handleMessage=async message=>{
    const requestSession=session;
    addMessage(message,'user');
    status.textContent=lang==='tr'?'DOĞRULANIYOR':'VERIFYING';
    talkId++;clearTimeout(talkTimer);setState('thinking');
    const backendReply=await askBackend(message);
    if(requestSession!==session)return;
    if(backendReply){
      addMessage(backendReply);
      status.textContent=lang==='tr'?'YANIT ALINDI':'REPLY RECEIVED';
      speak(backendReply);
      return;
    }
    const result=safeIntent(message);
    addMessage(result.answer,'assistant',result.route,result.label);
    status.textContent=endpoint?(lang==='tr'?'GÜVENLİ YEREL YÖNLENDİRME':'SAFE LOCAL GUIDANCE'):(lang==='tr'?'GÜVENLİ OSKA BİLGİ KATMANI':'SAFE OSKA KNOWLEDGE');
    speak(result.answer);
  };
  const setMode=nextMode=>{
    const next=nextMode==='chat'?'chat':'ai';
    const changed=mode!==next;
    mode=next;
    root.dataset.mode=mode;
    const textOnly=mode==='chat';
    if(changed)log.innerHTML='';
    if(roleLabel)roleLabel.textContent=textOnly?(lang==='tr'?'YAZILI SOHBET':'TEXT CHAT'):(lang==='tr'?'DİJİTAL ASİSTAN':'DIGITAL ASSISTANT');
    if(title)title.textContent=textOnly?(lang==='tr'?'Nasıl yardımcı olabilirim?':'How can I help?'):(lang==='tr'?'Nasıl yönlendireyim?':'How can I guide you?');
    if(description)description.textContent=textOnly?(lang==='tr'?'OSKA hakkında yazılı bilgi ve güvenli yönlendirme.':'Written OSKA information and safe guidance.'):(lang==='tr'?'Koleksiyon, üretim, markaya özel üretim ve teklif için OSKA asistanı.':'OSKA’s central assistant for collections, manufacturing, private label and RFQ.');
    if(handoff)handoff.textContent=lang==='tr'?'İletişim formu':'Contact form';
    voiceButton.hidden=textOnly;
    mic.hidden=textOnly;
    voiceOn=mode==='ai';
    voiceButton.setAttribute('aria-pressed',String(voiceOn));
    voiceButton.setAttribute('aria-label',voiceOn?(lang==='tr'?'Sesi kapat':'Mute voice'):(lang==='tr'?'Sesi aç':'Enable voice'));
    if(textOnly&&'speechSynthesis' in window)speechSynthesis.cancel();
  };
  const show=(nextMode='ai')=>{
    session++;
    stopListening();
    setMode(nextMode);
    clearTimeout(hideTimer);
    cancelAnimationFrame(openFrame);
    if(!panel.contains(document.activeElement))previousFocus=document.activeElement;
    root.hidden=false;
    root.inert=false;
    root.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('oska-ai-open');
    aiOpenButtons.forEach(button=>button.setAttribute('aria-expanded',String(mode==='ai')));
    liveOpenButtons.forEach(button=>button.setAttribute('aria-expanded',String(mode==='chat')));
    status.textContent=mode==='chat'?(lang==='tr'?'YAZILI SOHBET HAZIR':'TEXT CHAT READY'):(endpoint?(lang==='tr'?'AI BAĞLANTISI HAZIR':'AI CONNECTION READY'):(lang==='tr'?'GÜVENLİ OSKA BİLGİ KATMANI':'SAFE OSKA KNOWLEDGE'));
    if(!log.children.length)addMessage(greetings[mode]);
    openFrame=requestAnimationFrame(()=>{
      root.classList.add('is-open');
      closeButton.focus({preventScroll:true});
    });
    speak(greetings[mode]);
  };
  const hide=(restoreFocus=true)=>{
    session++;
    stopListening();
    talkId++;clearTimeout(talkTimer);setState('');
    cancelAnimationFrame(openFrame);
    clearTimeout(hideTimer);
    root.classList.remove('is-open');
    if(restoreFocus&&previousFocus?.isConnected)previousFocus.focus({preventScroll:true});
    root.inert=true;
    root.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('oska-ai-open');
    openButtons.forEach(button=>button.setAttribute('aria-expanded','false'));
    if('speechSynthesis' in window)speechSynthesis.cancel();
    const finish=()=>{
      root.classList.remove('is-speaking');
      root.hidden=true;
    };
    if(reduced)finish();else hideTimer=window.setTimeout(finish,280);
  };
  const trap=event=>{
    if(event.key==='Escape'){event.preventDefault();hide();return}
    if(event.key!=='Tab')return;
    const items=focusable();
    if(!items.length){event.preventDefault();panel.focus();return}
    const first=items[0],last=items[items.length-1];
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}
  };
  aiOpenButtons.forEach(button=>button.addEventListener('click',()=>root.classList.contains('is-open')&&mode==='ai'?hide():show('ai')));
  liveOpenButtons.forEach(button=>button.addEventListener('click',()=>root.classList.contains('is-open')&&mode==='chat'?hide():show('chat')));
  closeButton.addEventListener('click',()=>hide());
  document.addEventListener('pointerdown',event=>{if(root.classList.contains('is-open')&&!panel.contains(event.target)&&!event.target.closest?.('[data-oska-concierge-open-top],[data-oska-live-chat-open]'))hide(false)});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&root.classList.contains('is-open')&&!root.contains(event.target)){event.preventDefault();hide();}});
  root.addEventListener('keydown',trap);
  voiceButton.addEventListener('click',()=>{
    voiceOn=!voiceOn;
    voiceButton.setAttribute('aria-pressed',String(voiceOn));
    voiceButton.setAttribute('aria-label',voiceOn?(lang==='tr'?'Sesi kapat':'Mute voice'):(lang==='tr'?'Sesi aç':'Enable voice'));
    if(!voiceOn&&'speechSynthesis' in window)speechSynthesis.cancel();
  });
  form.addEventListener('submit',event=>{
    event.preventDefault();
    const message=input.value.trim();
    if(!message)return;
    input.value='';
    handleMessage(message);
  });
  if(!Recognition)mic.disabled=true;
  else mic.addEventListener('click',()=>{
    try{
      stopListening();
      recognition=new Recognition();
      const voiceSession=session;
      recognition.lang=lang==='tr'?'tr-TR':'en-US';
      recognition.interimResults=false;
      recognition.continuous=false;
      status.textContent=lang==='tr'?'DİNLİYORUM':'LISTENING';
      talkId++;clearTimeout(talkTimer);if('speechSynthesis' in window)speechSynthesis.cancel();setState('listening');
      recognition.onresult=event=>{
        const text=event.results?.[0]?.[0]?.transcript?.trim();
        if(text&&voiceSession===session&&!root.inert)handleMessage(text);
      };
      recognition.onerror=()=>{root.classList.remove('is-listening');status.textContent=lang==='tr'?'SESLİ GİRİŞ KULLANILAMADI':'VOICE INPUT UNAVAILABLE'};
      recognition.onend=()=>{root.classList.remove('is-listening');if(status.textContent===(lang==='tr'?'DİNLİYORUM':'LISTENING'))status.textContent=lang==='tr'?'GÜVENLİ OSKA BİLGİ KATMANI':'SAFE OSKA KNOWLEDGE'};
      recognition.start();
    }catch(error){root.classList.remove('is-listening');status.textContent=lang==='tr'?'SESLİ GİRİŞ KULLANILAMADI':'VOICE INPUT UNAVAILABLE'}
  });
})();
